import { Observable, BehaviorSubject } from 'rxjs';
import { Block } from '../models/block';
import { GridPosition } from '../models/grid-position';

export class Cell {
  public readonly id: string;
  public readonly row: number;
  public readonly column: number;
  public readonly positionOnGrid: GridPosition;

  subgridIndex = 0;

  get blockData$(): Observable<{ block: Block | null; displayIndex: number }> {
    return this._blockData.asObservable();
  }
  get currentBlock(): Block | null {
    return this._blockData.getValue().block;
  }
  get blockMultiplier(): number | undefined {
    return this._blockData.value?.block?.multiplier ?? undefined;
  }
  get points$(): Observable<{ amount: number; display: string }> {
    return this._points.asObservable();
  }
  get currentPointsAmount(): number {
    return this._points.value.amount;
  }
  get currentPoints(): { amount: number; display: string } {
    return this._points.value;
  }

  private _points = new BehaviorSubject<{ amount: number; display: string }>({
    amount: 0,
    display: '0',
  });
  private _blockData = new BehaviorSubject<{ block: Block | null; displayIndex: number }>({
    block: null,
    displayIndex: 0,
  });

  constructor(id: string) {
    this.id = id;
    this.row = this.idPosition(0);
    this.column = this.idPosition(1);
    this.positionOnGrid = new GridPosition(this.row, this.column);
  }

  public setPoints(points: number, pointsDisplay: string) {
    this._points.next({ amount: points, display: pointsDisplay });
  }

  public setBlock(data: { block: Block | null; displayIndex: number }): void {
    this._points.next({
      amount: 0,
      display: '0',
    }); // Reset points
    this._blockData.next(data);
  }

  private idPosition(position: number): number {
    return Number(this.id?.[position]) || 0;
  }
}
